import Api from '@/api/offer-api'
import SearchApi from '@/api/search-api'

const getOffer = async (context, payload) => {
    context.commit('OFFER_FETCHING');
    let result  = null;
    if(!payload.id && payload.slug) {
      result = await Api.getOfferBySlug(payload.slug);
    }else {
      result = await Api.getOffer(payload.id);
   
    }
    if(result){
      context.commit('OFFER_LOADED',result);
    }else{
      context.commit('OFFER_NOT_FOUND');
    }
 
}

const getOfferData = async (context, payload) => {
  var result = await Api.getOfferData(payload.id);
  if(result){
    context.commit('OFFER_DATA_RECEIVED',result);
  }
}

const getFurtherOffers = async (context) => {
  let data = await SearchApi.find(  {
    sortBy: "random",
    page: 1,
    pageSize: 3
  });
  if(data && data.results){
    context.commit('FURTHER_OFFERS_LOADED',data.results);
  }
}

export default {
    getOffer,
    getFurtherOffers,
    getOfferData
  };